/** Roofless timber support for the existing Moonfen watchtower platform. */
export const FENWATCH_PROP_TEMPLATES = {
  fenwatch_beacon_frame: {
    kind: 'village_house', name: 'Fenwatch timber beacon',
    frame: { w: 430, h: 364 }, band: 'architecture',
  },
} as const;
export type FenwatchPropTemplate = keyof typeof FENWATCH_PROP_TEMPLATES;
